import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import InsuranceHero from "../../components/landing/InsuranceHero";

export default function Insurance() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      <div className="sticky top-0 z-20 px-4 py-3 bg-white/80 backdrop-blur-sm border-b border-gray-100 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <button
            type="button"
            onClick={() => navigate("/insurance/choose")}
            className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 rounded-lg border border-gray-300 bg-white hover:bg-gray-50 transition-colors"
          >
            <ChevronLeft size={16} />
            Choose different insurance
          </button>
        </div>
      </div>
      <InsuranceHero />
    </div>
  );
}